export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 7_08.f249c24d.jpg";